import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import './LandingPage.css';
import Nav from '../Nav/Nav';
import Footer from '../Footer/Footer';

// CUSTOM COMPONENTS
import LoginForm from '../LoginForm/LoginForm';

function LandingPage() {
  const history = useHistory();

  const onRegister = (event) => {
    history.push('/registration');
  };

  return (
    <>
    <Nav />
    <div id='landing-page'>
      <div id='landing-container' className="container">
        <div className="grid">
            <div id='login-div' className="grid-col col-4">
              <LoginForm />
            </div>
            <div id='login-text-div' className="grid-col col-8">
              <h4>"SHARE WITH THE LORD'S PEOPLE WHO ARE IN NEED. PRACTICE HOSPITALITY." ROMANS 12:13</h4>
              <p>Welcome to the Furniture Mission of the Red River Valley (FMRRV) request portal. If you are FMRRV
              staff, please use the login form to the left. If you are a referral partner, plese click the <em>'Referral
              Form'</em>  link in the nav bar above. If you are in need of FMRRV's services, plese click the link
              below to be re-directed to a list of referral partners that will be able to assist you. Thank you and
              God bless. </p>
              <a href="https://www.furnituremissionrrv.org/need-our-services.html">Furniture Mission of the Red River Valley Client Portal</a>
            </div>
        </div>
      </div>
    </div>
    <Footer />
    </>
  );
}

export default LandingPage;
